// extracted by mini-css-extract-plugin
export default {"scrollContainer":"assessment-included-fop_scrollContainer__R2tjy","card":"assessment-included-fop_card__O0eoX","chip":"assessment-included-fop_chip__Opn7H"};